import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import Logo from '../components/Logo';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setDone(true);
    } catch (err) {
      toast.error('Noe gikk galt. Prøv igjen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-8 hover:opacity-80">
          <Logo variant="full" height={40} />
        </Link>
        <div className="bg-card border border-border rounded-md p-6">
          <h1 className="font-heading text-2xl font-bold mb-2">Glemt passord?</h1>
          <p className="text-sm text-muted-foreground mb-4">
            Skriv inn e-postadressen din. Hvis kontoen finnes, sender vi en lenke for å lage et nytt passord.
          </p>
          {done ? (
            <div className="space-y-3">
              <div className="p-4 rounded-md bg-success/10 text-sm" data-testid="forgot-success">
                Hvis e-posten finnes hos oss, har vi sendt en tilbakestillingslenke. Sjekk innboksen.
              </div>
              <Button asChild variant="outline" className="w-full">
                <Link to="/login">Tilbake til pålogging</Link>
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email">E-post</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="din@epost.no"
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
                {loading ? 'Sender...' : 'Send tilbakestillingslenke'}
              </Button>
              <div className="text-center text-sm">
                <Link to="/login" className="text-primary hover:underline">Tilbake til pålogging</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
